import { ListGroupItemHeading as _ListGroupItemHeading, ListGroupItemHeadingProps as _ListGroupItemHeadingProps } from "reactstrap";

    export const ListGroupItemHeading = _ListGroupItemHeading;
    export type ListGroupItemHeadingProps = _ListGroupItemHeadingProps;
    